"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerGrid = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var PowerGrid = (function (_super) {
    __extends(PowerGrid, _super);
    function PowerGrid() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.POWER_GRID,
            tags: [Tags_1.Tags.ENERGY],
            cost: 18,
            metadata: {
                cardNumber: '102',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(1).slash().energy(1, { played: Options_1.played }); });
                }),
                description: 'Increase your Energy production step for each Power tag you have, including this.',
            },
        }) || this;
    }
    PowerGrid.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1 + player.getTagCount(Tags_1.Tags.ENERGY), { log: true });
        return undefined;
    };
    return PowerGrid;
}(Card_1.Card));
exports.PowerGrid = PowerGrid;
